var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgExcelButton = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1235",
    "data-name": "Group 1235",
    transform: "translate(-1667 -281)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4",
    "data-name": "Ellipse 4",
    cx: 25,
    cy: 25,
    r: 25,
    transform: "translate(1667 281)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("g", {
    id: "archivo-xls",
    transform: "translate(1649.622 292.03)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55",
    "data-name": "Path 55",
    d: "M80.912,5.9a.551.551,0,0,0-.161-.389L75.275.031a.551.551,0,0,0-.389-.161H59.771a.551.551,0,0,0-.551.551v27.1a.551.551,0,0,0,.551.551h20.59a.551.551,0,0,0,.551-.551Z",
    transform: "translate(-27.715)",
    fill: "#f1f1f1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56",
    "data-name": "Path 56",
    d: "M349.648,5.76a.544.544,0,0,0-.143-.252L344.029.031a.551.551,0,0,0-.389-.161V5.1a.661.661,0,0,0,.661.661Z",
    transform: "translate(-296.469 0)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57",
    "data-name": "Path 57",
    d: "M349.658,95.461h-5.347a.661.661,0,0,1-.661-.661v.559a.765.765,0,0,0,.682.826h5.343V95.6A.355.355,0,0,0,349.658,95.461Z",
    transform: "translate(-296.479 -89.701)",
    fill: "#e8e8e8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58",
    "data-name": "Path 58",
    d: "M33.688,215.34,32.2,216.832h1.488Z",
    transform: "translate(-2.183 -203.602)",
    fill: "#008275"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59",
    "data-name": "Path 59",
    d: "M452.73,215.34l1.488,1.492H452.73Z",
    transform: "translate(-399.551 -203.602)",
    fill: "#008275"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60",
    "data-name": "Path 60",
    d: "M54.247,248.377H30.441a.551.551,0,0,1-.551-.551v-8.446a.551.551,0,0,1,.551-.551H54.247a.551.551,0,0,1,.551.551v8.445a.551.551,0,0,1-.551.551Z",
    transform: "translate(0 -225.799)",
    fill: "#00a99d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61",
    "data-name": "Path 61",
    d: "M59.21,412.17H80.9v.714H59.21Z",
    transform: "translate(-27.705 -389.591)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_59",
    "data-name": "Group 59",
    transform: "translate(37.241 16.125)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62",
    "data-name": "Path 62",
    d: "M166.892,298.855a.441.441,0,0,1-.147.33.459.459,0,0,1-.33.141.432.432,0,0,1-.336-.165l-.948-1.135-.964,1.135a.427.427,0,0,1-.33.165.458.458,0,0,1-.33-.144.444.444,0,0,1-.03-.628l1.058-1.223-1.031-1.2a.46.46,0,0,1-.121-.3.441.441,0,0,1,.146-.328.468.468,0,0,1,.334-.14.433.433,0,0,1,.336.165l.931,1.1.926-1.1a.4.4,0,0,1,.325-.165.466.466,0,0,1,.333.14.441.441,0,0,1,.146.328.452.452,0,0,1-.116.3l-1.03,1.2,1.052,1.223A.449.449,0,0,1,166.892,298.855Z",
    transform: "translate(-163.36 -295.349)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63",
    "data-name": "Path 63",
    d: "M236.3,299.2a.476.476,0,0,1-.121-.353V295.9a.489.489,0,0,1,.135-.361.5.5,0,0,1,.366-.135.514.514,0,0,1,.375.135.484.484,0,0,1,.138.361v2.6h1.267q.479,0,.48.413a.378.378,0,0,1-.119.308.553.553,0,0,1-.361.1h-1.813a.47.47,0,0,1-.347-.122Z",
    transform: "translate(-232.169 -295.384)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64",
    "data-name": "Path 64",
    d: "M290.591,298.884a1.862,1.862,0,0,1-.621-.267.465.465,0,0,1-.135-.149.417.417,0,0,1-.041-.2.441.441,0,0,1,.1-.286.292.292,0,0,1,.231-.121.427.427,0,0,1,.138.022.812.812,0,0,1,.165.083,1.818,1.818,0,0,0,.449.182,2.1,2.1,0,0,0,.5.055,1.025,1.025,0,0,0,.5-.1.31.31,0,0,0,.168-.284.259.259,0,0,0-.157-.218,2.191,2.191,0,0,0-.6-.179,3.494,3.494,0,0,1-.854-.275,1.017,1.017,0,0,1-.432-.377,1.123,1.123,0,0,1,.085-1.166,1.4,1.4,0,0,1,.574-.447,2.01,2.01,0,0,1,.826-.165,2.649,2.649,0,0,1,.716.088,1.807,1.807,0,0,1,.573.275.449.449,0,0,1,.141.151.423.423,0,0,1,.041.2.449.449,0,0,1-.1.286.286.286,0,0,1-.229.121.441.441,0,0,1-.132-.019.885.885,0,0,1-.171-.085c-.018-.011-.071-.04-.157-.085a1.258,1.258,0,0,0-.3-.11,1.63,1.63,0,0,0-.378-.041.838.838,0,0,0-.452.107.323.323,0,0,0-.171.284.241.241,0,0,0,.061.171.606.606,0,0,0,.226.129,3.282,3.282,0,0,0,.49.129,3.278,3.278,0,0,1,.832.279,1.063,1.063,0,0,1,.43.377.982.982,0,0,1,.127.507,1.057,1.057,0,0,1-.2.642,1.3,1.3,0,0,1-.57.43,2.211,2.211,0,0,1-.852.152A3.291,3.291,0,0,1,290.591,298.884Z",
    transform: "translate(-282.83 -294.995)",
    fill: "#fff"
  }))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgExcelButton, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/excel-button.611354a7.svg";
export { ForwardRef as ReactComponent };